export const LIVEART_CUSTOM_DESIGN = 'Liveart Custom Design';
export const LIVEART_PRODUCT = 'Liveart Product';

export const UNKNOWN_MANUFACTURER = 'unknown';

export const META_NAMESPACE = import.meta.env.NAMESPACE || 'LiveArt';
export const META_STATUS_KEY = 'send_manufacturer_status';
export const META_SHIP_DATE_KEY = 'send_manufacturer_ship_date';
export const SENT_TO_MAN_TAG = 'Submitted to Manufacturer';
export const enum Manufacturer {
  Pearsox = 'pear sox',
  MkSocks = 'mk socks',
  Uniforms = 'uniforms',
}
export const MANUFACTURER_OPTIONS: Manufacturer[] = [Manufacturer.Pearsox, Manufacturer.MkSocks, Manufacturer.Uniforms];
export const META_GARMENT_ID_KEY = 'garment_id';